/** ISO 4217 currencies — USD, GBP, EUR first; remainder A→Z by name. */

const PRIORITY_CODES = ["USD", "GBP", "EUR"];

/** code, label, symbol, flag (display) */
const ALL = [
  { code: "USD", label: "US Dollar", symbol: "$", flag: "🇺🇸" },
  { code: "GBP", label: "British Pound", symbol: "£", flag: "🇬🇧" },
  { code: "EUR", label: "Euro", symbol: "€", flag: "🇪🇺" },
  { code: "AED", label: "UAE Dirham", symbol: "د.إ", flag: "🇦🇪" },
  { code: "ARS", label: "Argentine Peso", symbol: "$", flag: "🇦🇷" },
  { code: "AUD", label: "Australian Dollar", symbol: "A$", flag: "🇦🇺" },
  { code: "BDT", label: "Bangladeshi Taka", symbol: "৳", flag: "🇧🇩" },
  { code: "BHD", label: "Bahraini Dinar", symbol: ".د.ب", flag: "🇧🇭" },
  { code: "BRL", label: "Brazilian Real", symbol: "R$", flag: "🇧🇷" },
  { code: "CAD", label: "Canadian Dollar", symbol: "C$", flag: "🇨🇦" },
  { code: "CHF", label: "Swiss Franc", symbol: "CHF", flag: "🇨🇭" },
  { code: "CLP", label: "Chilean Peso", symbol: "$", flag: "🇨🇱" },
  { code: "CNY", label: "Chinese Yuan", symbol: "¥", flag: "🇨🇳" },
  { code: "COP", label: "Colombian Peso", symbol: "$", flag: "🇨🇴" },
  { code: "CZK", label: "Czech Koruna", symbol: "Kč", flag: "🇨🇿" },
  { code: "DKK", label: "Danish Krone", symbol: "kr", flag: "🇩🇰" },
  { code: "EGP", label: "Egyptian Pound", symbol: "E£", flag: "🇪🇬" },
  { code: "GHS", label: "Ghanaian Cedi", symbol: "₵", flag: "🇬🇭" },
  { code: "HKD", label: "Hong Kong Dollar", symbol: "HK$", flag: "🇭🇰" },
  { code: "HUF", label: "Hungarian Forint", symbol: "Ft", flag: "🇭🇺" },
  { code: "IDR", label: "Indonesian Rupiah", symbol: "Rp", flag: "🇮🇩" },
  { code: "ILS", label: "Israeli Shekel", symbol: "₪", flag: "🇮🇱" },
  { code: "INR", label: "Indian Rupee", symbol: "₹", flag: "🇮🇳" },
  { code: "JPY", label: "Japanese Yen", symbol: "¥", flag: "🇯🇵" },
  { code: "KES", label: "Kenyan Shilling", symbol: "KSh", flag: "🇰🇪" },
  { code: "KRW", label: "South Korean Won", symbol: "₩", flag: "🇰🇷" },
  { code: "KWD", label: "Kuwaiti Dinar", symbol: "د.ك", flag: "🇰🇼" },
  { code: "MAD", label: "Moroccan Dirham", symbol: "د.م.", flag: "🇲🇦" },
  { code: "MXN", label: "Mexican Peso", symbol: "$", flag: "🇲🇽" },
  { code: "MYR", label: "Malaysian Ringgit", symbol: "RM", flag: "🇲🇾" },
  { code: "NGN", label: "Nigerian Naira", symbol: "₦", flag: "🇳🇬" },
  { code: "NOK", label: "Norwegian Krone", symbol: "kr", flag: "🇳🇴" },
  { code: "NZD", label: "New Zealand Dollar", symbol: "NZ$", flag: "🇳🇿" },
  { code: "OMR", label: "Omani Rial", symbol: "ر.ع.", flag: "🇴🇲" },
  { code: "PEN", label: "Peruvian Sol", symbol: "S/", flag: "🇵🇪" },
  { code: "PHP", label: "Philippine Peso", symbol: "₱", flag: "🇵🇭" },
  { code: "PKR", label: "Pakistani Rupee", symbol: "₨", flag: "🇵🇰" },
  { code: "PLN", label: "Polish Złoty", symbol: "zł", flag: "🇵🇱" },
  { code: "QAR", label: "Qatari Riyal", symbol: "ر.ق", flag: "🇶🇦" },
  { code: "RON", label: "Romanian Leu", symbol: "lei", flag: "🇷🇴" },
  { code: "RUB", label: "Russian Ruble", symbol: "₽", flag: "🇷🇺" },
  { code: "SAR", label: "Saudi Riyal", symbol: "ر.س", flag: "🇸🇦" },
  { code: "SEK", label: "Swedish Krona", symbol: "kr", flag: "🇸🇪" },
  { code: "SGD", label: "Singapore Dollar", symbol: "S$", flag: "🇸🇬" },
  { code: "THB", label: "Thai Baht", symbol: "฿", flag: "🇹🇭" },
  { code: "TRY", label: "Turkish Lira", symbol: "₺", flag: "🇹🇷" },
  { code: "TWD", label: "Taiwan Dollar", symbol: "NT$", flag: "🇹🇼" },
  { code: "TZS", label: "Tanzanian Shilling", symbol: "TSh", flag: "🇹🇿" },
  { code: "UAH", label: "Ukrainian Hryvnia", symbol: "₴", flag: "🇺🇦" },
  { code: "UGX", label: "Ugandan Shilling", symbol: "USh", flag: "🇺🇬" },
  { code: "VND", label: "Vietnamese Dong", symbol: "₫", flag: "🇻🇳" },
  { code: "XAF", label: "Central African CFA Franc", symbol: "FCFA", flag: "🇨🇲" },
  { code: "XOF", label: "West African CFA Franc", symbol: "CFA", flag: "🇸🇳" },
  { code: "ZAR", label: "South African Rand", symbol: "R", flag: "🇿🇦" },
];

const byCode = Object.fromEntries(ALL.map((c) => [c.code, c]));

const priority = PRIORITY_CODES.map((code) => byCode[code]).filter(Boolean);
const rest = ALL.filter((c) => !PRIORITY_CODES.includes(c.code)).sort((a, b) =>
  a.label.localeCompare(b.label)
);

/** Sorted list for dropdowns */
export const CURRENCIES = [...priority, ...rest];

export const DEFAULT_CURRENCY = "NGN";

/** Empty value for onboarding — user must pick explicitly */
export const CURRENCY_UNSELECTED = "";

export const CURRENCY_PLACEHOLDER_LABEL = "Choose your currency";

export function getCurrency(code) {
  return byCode[code] || byCode[DEFAULT_CURRENCY];
}

export function getCurrencySymbol(code) {
  return getCurrency(code).symbol;
}

export function formatCurrencyLabel(c) {
  return `${c.flag} ${c.label} (${c.symbol})`;
}

/** Search by code, name, or symbol — e.g. "naira", "NGN", "₦". */
export function filterCurrencies(query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return CURRENCIES;
  return CURRENCIES.filter(
    (c) =>
      c.code.toLowerCase().includes(q) ||
      c.label.toLowerCase().includes(q) ||
      c.symbol.toLowerCase().includes(q)
  );
}
